// extracted by mini-css-extract-plugin
export default {"button":"QUaL0","button--bought":"WbKSn"};